import { render } from "./RuiBackdrop.vue?vue&type=template&id=7568fb7f&scoped=true"
import script from "./RuiBackdrop.vue?vue&type=script&lang=ts"
export * from "./RuiBackdrop.vue?vue&type=script&lang=ts"

import "./RuiBackdrop.vue?vue&type=style&index=0&id=7568fb7f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7568fb7f"

export default script